import { render, staticRenderFns } from "./clipper-range.vue?vue&type=template&id=52756c6c&scoped=true"
import script from "./clipper-range.vue?vue&type=script&lang=js"
export * from "./clipper-range.vue?vue&type=script&lang=js"
import style0 from "./clipper-range.vue?vue&type=style&index=0&id=52756c6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52756c6c",
  null
  
)

export default component.exports